export default __webpack_public_path__ + "static/media/sodium.254e8c84.jpg";